import { store as auth } from '@/views/auth'
import { store as perfil } from '@/views/perfil'

export default {
  auth,
  perfil
}